import { Component, inject } from '@angular/core';
import { IonButton } from '@ionic/angular/ion-button';
import { IonContent } from '@ionic/angular/ion-content';
import { TranslocoPipe } from '@jsverse/transloco';
import { Browser } from '@capacitor/browser';
import { ModalService } from '@services/utility-services/modal.service';
import { IconDisplayComponent } from '@shared/components/icon-display/icon-display.component';
import { TaskNotificationModalDataModel } from '@shared/models/notification/task-notification-modal-data.model';

/**
 * The Jahreszahlen sheet (BRO-1177). `notificationUrl` is an absolute Kundenportal link, so the
 * CTA hands it to the system browser — there is no in-app route for this task.
 */
@Component({
  selector: 'app-annual-figures-modal',
  templateUrl: './annual-figures-modal.component.html',
  styleUrls: ['./annual-figures-modal.component.scss'],
  imports: [
    IonContent,
    TranslocoPipe,
    IonButton,
    IconDisplayComponent
  ]
})
export class AnnualFiguresModalComponent {
  protected readonly modalService = inject(ModalService);

  public notification: TaskNotificationModalDataModel | null = null;

  protected async openExternalWebsiteAsync(link: string | null | undefined): Promise<void> {
    if (!link) {
      return;
    }

    await Browser.open({ url: link });
    this.modalService.closeModal();
  }
}
